/**
 * Access token store — module-level singleton (F7b T7b.1).
 *
 * Tenant API (F5 T5.7 `requireTenantAuth`) wymaga `Authorization: Bearer <access_token>`.
 * Access token jest zwracany w body response z `/api/auth/login` + `/api/auth/login/2fa` +
 * `/api/auth/refresh`. Refresh token żyje w httpOnly cookie i nie jest dostępny z JS.
 *
 * Trzymamy access token w module-level variable (nie localStorage — XSS risk). Axios
 * request interceptor sięga po niego poza React-em, dlatego nie może to być Context state.
 * TenantAuthContext (T7b.1) synchronizuje state React z tym store (set po loginie, clear
 * po logout-cie). Refresh queue (T7b.1) aktualizuje store po rotacji.
 *
 * Scope: tylko tenant. Admin SPA używa cookies (opaque session), bez Bearer.
 */

let accessToken: string | null = null;
let subscribers: Array<(token: string | null) => void> = [];

export function setAccessToken(token: string | null): void {
  accessToken = token;
  for (const cb of subscribers) cb(token);
}

export function getAccessToken(): string | null {
  return accessToken;
}

export function clearAccessToken(): void {
  setAccessToken(null);
}

/**
 * Zapisuje callback wywoływany przy każdej zmianie tokenu. Zwraca `unsubscribe`.
 * Używane przez TenantAuthContext żeby re-render reagował na zmiany (logout-on-reuse
 * w refresh-queue wywołuje `clearAccessToken` spoza React).
 */
export function subscribeAccessToken(cb: (token: string | null) => void): () => void {
  subscribers.push(cb);
  return () => {
    subscribers = subscribers.filter((s) => s !== cb);
  };
}
